import React, { useState, useEffect } from "react";
import Constants from "../../constants/Constants";
import { GiSmartphone } from "react-icons/gi";
import VideoAnnoucment from "../VideoAnnoucment";
const RequestCustom = ({ site }) => {
  const [vidLength, setVidLength] = useState("");
  const [total, setTotal] = useState(0);
  const [describe, setDescribe] = useState("");
  const [hasError, setHasError] = useState("");
  const [stored, setStored] = useState("n");
  const [locMsg, setLocMsg] = useState("");
  const [vertical, setVertical] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showRequestVideo, setShowRequestVideo] = useState(false);
  const [pending, setPending] = useState(false);
  const [pendingMsg, setPendingMsg] = useState(
    `Thank you.  Waiting while|accepts this order.  Please revisit this page to see the status of your order.`
  );
  const [paying, setPaying] = useState(false);

  const hasPreviewVideo = [];

  useEffect(() => {
    // if (localStorage.getItem(`custom-${site.id}`) === null) {
    //   localStorage.setItem(`custom-${site.id}`, `watched`);
    //   setShowRequestVideo(true);
    // }
    fetch(`${Constants.API}has-custom-req.php?siteid=${site.id}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.cstatus !== "none") {
          setDescribe(res.info.custom_req);
          setLocMsg(res.info.custom_loc);
          setVidLength(parseInt(res.info.video_length));
          setTotal(parseInt(res.info.video_length) * 100);
          if (res.info.angle === "landscape") {
            setVertical(false);
          }
          if (res.cstatus !== "init") {
            setPending(true);
            switch (res.cstatus) {
              case "accepted":
                setPendingMsg(
                  "|Is Making Your Order!  She will DM you when it is finished and it will be in your library"
                );
                break;
              default:
                setPendingMsg(
                  "Thank you.  Waiting while|accepts this order.  Please revisit this page to see the status of your order."
                );
            }
          } else {
            setStored(res.order_number);
          }
        }
        setLoading(false);
      });
  }, [site.id]);

  const handleVidLength = (e) => {
    if (e.target.value === "") {
      setVidLength("");
      setTotal(0);
      return;
    }
    const long = parseInt(e.target.value);
    // if (long >= 4) {
    //   setTotal(long * 100);
    //   setVidLength(long);
    //   return;
    // }
    setVidLength(long);
    setTotal(300); //sets minimum price to $300
  };
  const handlePaying = () => {
    if (paying) return;
    if (pending) return;
    if (vidLength === "") {
      setHasError("please select how long you want your video to be.");
      return;
    }
    // if (total < 300) {
    //   setHasError("anything less then $300 is not accepted.");
    //   return;
    // }
    if (describe.length < 15) {
      setHasError(
        "please be a little more descriptive, greater then 15 characters at least!"
      );
      return;
    }
    if (describe.length > 3000) {
      setHasError(
        "alright a little TOO descriptive, less then 1000 characters please."
      );
      return;
    }
    if (locMsg.length < 3) {
      setHasError(
        "please provide a location, this does not seem to be descriptive enough."
      );
      return;
    }
    if (locMsg.length > 1000) {
      setHasError(
        "Location description is too long!  Keep it under 100 characters please."
      );
      return;
    }
    // if (vidLength < 3) {
    //   setHasError("video length can be a minimum of 5 minutes.");
    //   return;
    // }
    setHasError("");
    setPaying(true);
    const formData = new FormData();
    formData.append("siteid", parseInt(site.id));
    formData.append("describe", describe);
    formData.append("location", locMsg);
    formData.append("stored", stored);
    formData.append("videolength", vidLength);
    let angle = "portrait";
    if (!vertical) {
      angle = "landscape";
    }
    formData.append("angle", angle);
    fetch(`${Constants.API}request-custom.php`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if ("error" in res) {
          setHasError(res.error);
          setPaying(false);
          return;
        }

        // TEMP
        setPending(true);
        setPendingMsg(
          "Thank you.  Waiting while|accepts this order.  Please revisit this page to see the status of your order."
        );
        setPaying(false);
        // TEMP

        // const goTo = `https://wnu.com/secure/services/?api=camcharge&action=auth&auth_amount=${res.auth_amount}&member_id=${res.member_id}&include_css=${res.include_css}&returnurl=${res.returnurl}&description=${res.x_description}&pburl=${res.pburl}&x_description=${res.x_description}&x_pkey=${res.x_pkey}&x_req=${res.x_req}&epoch_digest=${res.epoch_digest}`;
        // let newWindow = window.open("/robots-working/", "_blank");

        // if (newWindow === null) {
        //   window.location.href = goTo;
        // } else {
        //   newWindow.location = goTo;
        // }
        // startPolling(res.x_pkey, newWindow);
      });

    // setTimeout(() => {
    //   setPending(true);
    //   setPaying(false);
    // }, 5000);
  };
  if (loading) {
    return (
      <div className="customs-container">
        <div className="loadingChat">Loading...</div>
      </div>
    );
  }
  return (
    <div className="customs-container">
      {hasError !== "" && (
        <div className="custom-error">
          <h2>Error:</h2>
          {hasError}
        </div>
      )}

      <div className="custom-option">
        <h1 className="custom-h1">Describe what you'd like</h1>
        <textarea
          name="whatyouwant"
          id="whatyouwant"
          rows="5"
          className="custom-wywl"
          placeholder="ex: start in a red dress..."
          value={describe}
          onChange={(e) => setDescribe(e.target.value)}
        />
      </div>
      <div className="custom-option">
        <h1 className="custom-h1">Location</h1>
        <input
          type="text"
          className="custom-input"
          placeholder="bed,shower,etc..."
          value={locMsg}
          onChange={(e) => setLocMsg(e.target.value)}
        />
      </div>
      <div className="custom-option inline">
        <h1 className="custom-h1">Length</h1>
        <select
          name="videolength"
          id="videoLength"
          value={vidLength}
          onChange={handleVidLength}
        >
          <option value="">select length</option>
          <option value="1">1 minutes</option>
          <option value="2">2 minutes</option>
          <option value="3">3 minutes</option>
          <option value="4">4 minutes</option>
          <option value="5">5+ minutes</option>
        </select>
      </div>
      <div className="custom-option inline">
        <h1 className="custom-h1">Angle</h1>
        <div className="customs-phone-group">
          <GiSmartphone
            className={vertical ? "phoneIcon selected" : "phoneIcon"}
            onClick={() => setVertical(true)}
          />
          <GiSmartphone
            className={vertical ? "phoneIcon horz" : "phoneIcon horz selected"}
            onClick={() => setVertical(false)}
          />
        </div>
      </div>
      <div className="custom-option center">
        <button
          className={paying ? "customs-pay active" : "customs-pay"}
          onClick={handlePaying}
        >
          {/* <span>Pay ${total}</span> */}
          <span>Request</span>
          <div
            className={
              paying ? "custom-spin-holder active" : "custom-spin-holder"
            }
            style={
              paying
                ? {
                    transform: `translate(${
                      total < 1000 ? `22` : `28`
                    }px, -50%)`,
                  }
                : null
            }
          >
            <div className="nk-spinner" />
          </div>
        </button>
      </div>
      {pending && (
        <div className="custom-pending">
          <div style={{ padding: "0px 30px" }}>
            {pendingMsg.split("|")[0]}{" "}
            <span>
              <strong>{site.site_name.split(" ")[0]}</strong>{" "}
              {site.site_name
                .split(" ")
                .splice(1, 3)
                .join(" ")}
            </span>{" "}
            {pendingMsg.split("|")[1]}
          </div>
        </div>
      )}
      {showRequestVideo && hasPreviewVideo.includes(parseInt(site.id)) && (
        <VideoAnnoucment
          setShowRequestVideo={setShowRequestVideo}
          url={site.site_url}
        />
      )}
    </div>
  );
};

export default RequestCustom;
